import { FollowingsDataWithAccountId } from '@/services/community'

export const checkIsFollowed = (
  followings: FollowingsDataWithAccountId[] | undefined,
  targetId: string,
) => followings?.some(({ htcAccountId }) => htcAccountId === targetId) || false
